/**
 * 产品定位卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input } from 'antd';

const { TextArea } = Input;

export const ProductPositioningCard: React.FC = () => {
    return (
        <Card title="🎨 产品定位" bordered={false}>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'core_value']}
                        label="核心价值主张"
                    >
                        <TextArea
                            rows={2}
                            placeholder="这个产品为用户解决什么核心问题？"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'unique_selling_points']}
                        label="独特卖点（USP）"
                    >
                        <TextArea
                            rows={3}
                            placeholder="列出产品的3-5个独特卖点..."
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default ProductPositioningCard;
